import ComponentLink from '../../application-core/ComponentLink';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SearchDropDown from '../SearchDropDown';

class ReportSearch extends Component {

  render() {

    const { componentIRI, property, defaultLang, graph, title, existingComponents,
      label, onFoundResource, inComponent, searchClass } = this.props;

    const componentType = componentIRI ?
      existingComponents.find(ec => ec.id === componentIRI).type
      :
      undefined;
    // If it's a collection we automatically override supplied values
    const componentSearch = componentType === "OrderedCollection" ?
      {
        inList: "http://www.w3.org/2004/02/skos/core#memberList",
        listOf: componentIRI
      }
      :
      componentType === "Collection" ?
        {
          predicate: "http://www.w3.org/2004/02/skos/core#member",
          value: componentIRI,
          reverse: true
        }
        :
        {
          predicate: inComponent,
          value: componentIRI
        };

    return (
      <SearchDropDown
        dataTest="find-resource"
        search={(value, lang) => {
          let search = [
            {
              predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
              value: searchClass
            },
            {
              predicate: [label],
              value: value,
              isExactMatch: false
            }
          ];
          if (inComponent && componentIRI) {
            search.push(componentSearch);
          }
          return {
            search,
            allowMissingResults: true,
            graph: [graph],
            language: lang,
            entailment: searchClass === "http://www.w3.org/2004/02/skos/core#Concept" ?
              ["propertyChain"]
              :
              [],
            predicates: [
              label,
              "http://www.w3.org/2004/02/skos/core#inScheme"
            ]
          };
        }}
        title={title}
        sortProp={property}
        suppressMessages={true}
        listDisplay={(result, lang) => <div data-test="result-label">
          <Typography variant="body2">
            <span data-test="result-text-words" style={{ wordBreak: 'break-word' }}>
              {result[property] && result[property][lang] ?
                Array.isArray(result[property][lang]) ?
                  result[property][lang].sort().join(" AND ")
                  :
                  result[property][lang]
                :
                result.id
              }
            </span>
          </Typography>
          {result.inScheme &&
            <div>
              {result.inScheme.map((scheme, index) => {
                if (index < 2 || (index < 3 && result.inScheme.length === 3)) {
                  return <ComponentLink
                    key={scheme}
                    id={scheme}
                    handleNotAvailable={true}
                    graph={graph}
                    defaultLang={defaultLang} />;
                }
                else return null;
              })}
              {result.inScheme.length > 3 &&
                <Typography
                  data-test="too-many-schemes"
                  variant="caption"
                  style={{ marginLeft: 20, marginTop: 4 }}>Additional schemes were also found ({result.inScheme.length - 2}).</Typography>
              }
            </div>
          }

        </div>
        }
        listSelectionDisplay={(result, lang) => {
          if (result[property] && result[property][lang]) {
            return Array.isArray(result[property][lang]) ?
              result[property][lang][0]
              :
              result[property][lang];
          }
          else return "";
        }}
        lang={defaultLang}
        chosen={onFoundResource} />
    );
  }

}

ReportSearch.defaultProps = {
  property: "prefLabel",
  title: "resource",
  existingComponents: [],
  label: "http://www.w3.org/2004/02/skos/core#prefLabel",
  inComponent: "http://www.w3.org/2004/02/skos/core#inScheme",
  searchClass: "http://www.w3.org/2004/02/skos/core#Concept"
};

ReportSearch.propTypes = {
  graph: PropTypes.string.isRequired,
  componentIRI: PropTypes.string,
  label: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired,
  title: PropTypes.string,
  existingComponents: PropTypes.array,
  searchClass: PropTypes.string.isRequired,
  inComponent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onFoundResource: PropTypes.func.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default ReportSearch;